import { create } from 'zustand';
import type { Participant } from '@matchroom/shared';

interface ParticipantStoreState {
  participants: Participant[];
  setParticipants: (participants: Participant[]) => void;
  addParticipant: (participant: Participant) => void;
  updateParticipant: (participant: Participant) => void;
  removeParticipant: (userId: string) => void;
  clear: () => void;
}

function dedupeParticipants(participants: Participant[]): Participant[] {
  const seen = new Set<string>();
  return participants.filter((p) => {
    if (seen.has(p.userId)) return false;
    seen.add(p.userId);
    return true;
  });
}

export const useParticipantStore = create<ParticipantStoreState>((set) => ({
  participants: [],
  setParticipants: (participants) => set({ participants: dedupeParticipants(participants) }),
  addParticipant: (participant) =>
    set((s) => ({
      participants: [...s.participants.filter((p) => p.userId !== participant.userId), participant],
    })),
  updateParticipant: (participant) =>
    set((s) => ({
      participants: s.participants.map((p) => (p.userId === participant.userId ? participant : p)),
    })),
  removeParticipant: (userId) =>
    set((s) => ({ participants: s.participants.filter((p) => p.userId !== userId) })),
  clear: () => set({ participants: [] }),
}));
